import { Controller } from "@hotwired/stimulus";

// Adds a click-to-clear ("x") affordance to a Fomantic ".ui.icon.input"
// search field, so clearing a search no longer requires selecting the whole
// text first. The leading icon doubles as a search glyph when the field is
// empty and a clear button once it has a value; Escape clears it too.
export default class extends Controller {
  static targets = ["input", "icon"];

  connect() {
    this.refresh();
  }

  refresh() {
    const hasValue = this.inputTarget.value.length > 0;

    this.iconTarget.classList.toggle("search", !hasValue);
    this.iconTarget.classList.toggle("close", hasValue);
    this.iconTarget.classList.toggle("link", hasValue);
    this.iconTarget.classList.toggle("pointer", hasValue);
    this.iconTarget.setAttribute("role", hasValue ? "button" : "presentation");
    this.iconTarget.tabIndex = hasValue ? 0 : -1;

    if (hasValue) {
      this.iconTarget.setAttribute("aria-label", "Clear search");
    } else {
      this.iconTarget.removeAttribute("aria-label");
    }
  }

  clear() {
    if (this.inputTarget.value.length === 0) return;

    this.inputTarget.value = "";
    this.inputTarget.focus();
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }));
    this.refresh();
  }

  clearOnKey(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.clear();
    }
  }
}
